import { Gavel } from "lucide-react";
import { JUDGE_LABELS, ROLE_BADGE, ROLE_LABELS } from "@/lib/mtg";

const JUDGE_CLS = { level_1: "border-sky-700/60 text-sky-200", level_2: "border-indigo-600/60 text-indigo-200", level_3: "border-violet-500/60 text-violet-200", senior: "border-amber-500/70 text-amber-200" };

export function JudgeBadge({ level, className = "" }) {
  if (!JUDGE_LABELS[level]) return null;
  return (
    <span data-testid={`judge-badge-${level}`} className={`inline-flex items-center gap-1 rounded border bg-black/40 px-2 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider ${JUDGE_CLS[level]} ${className}`}>
      <Gavel className="h-3 w-3" aria-hidden />{JUDGE_LABELS[level]}
    </span>
  );
}

export function RoleBadge({ role, className = "" }) {
  if (!role) return null;
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={`inline-flex items-center rounded px-2 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider ${ROLE_BADGE[role] || ROLE_BADGE.member} ${className}`}
    >
      {ROLE_LABELS[role] || role}
    </span>
  );
}

const VIS_CLS = {
  public: "border-emerald-600/50 text-emerald-300",
  unlisted: "border-amber-600/50 text-amber-300",
  private: "border-rose-600/50 text-rose-300",
};

export function VisibilityBadge({ visibility }) {
  return (
    <span
      data-testid={`visibility-badge-${visibility}`}
      className={`inline-flex items-center rounded border bg-black/60 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider ${VIS_CLS[visibility]}`}
    >
      {visibility}
    </span>
  );
}
